import schemaResolver from '.';

/**
 * Organiser schemata resolver.
 * This pure function transforms an organiser details object to a single element list of schemata.
 */

export const organiserResolver = organiser => organiser && {
  name: organiser.title,
  // Excerpt is optional
  ...(organiser.excerpt && {
    description: organiser.excerpt,
  }),
  url: organiser.canonical,
  // Logo is optional
  ...((organiser.images && organiser.images.logo) && {
    logo: organiser.images.logo.thumbnail,
  }),
};

const resolver = obj => [schemaResolver(organiserResolver(obj), 'Organization')];

export default resolver;



// WEBPACK FOOTER //
// ./app/src/state/resolvers/schema/organiser.js